export default "__VITE_ASSET__576d89b6__"